import type { MarketIndicator } from "@/types/market-status"
import client from "./client"

export async function getMarketIndicators(params: {
  type?: string
  market?: string
  from?: string
  to?: string
}): Promise<MarketIndicator[]> {
  const { data } = await client.get<MarketIndicator[]>("/api/market-indicators", { params })
  return data
}

export async function collectIntradayMarketIndicators(): Promise<Record<string, string>> {
  const { data } = await client.post<Record<string, string>>("/api/market-indicators/collect/intraday")
  return data
}
